import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../CSS/ContactUs.css';
import useIsMobile from '../Components/UseIsMobile.js';

const ContactUs = () => {
  const form = useRef();
  const isMobile = useIsMobile();

  const [expanded, setExpanded] = useState(null);
  const [expandedRFI, setExpandedRFI] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_dhgtf7o', 'template_2oqlyys', form.current, 'CSxb2cjoKlU_BpSCG')
      .then(() => {
        form.current.reset();
      })
      .catch((error) => {
        console.log(error.text);
      });
  };

  const toggleQuestion = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const toggleRFI = (index) => {
    setExpandedRFI(expandedRFI === index ? null : index);
  };

  const questions = [
    { question: 'Can I request a group profile that is not on the website?', answer: 'Yes if you do not see the profile needed, you may complete a "Request for Information (RFI)" to request a new group profile be created. Additional fees may apply for some but will be discussed with you before project launch.' },
    { question: 'Can I get historical data not on the website?', answer: 'Yes, you may complete a "Request for Information (RFI)", additional fees may apply. See "Pricing" for information.' },
    { question: 'How many years does the website hold for historical data?', answer: 'Orion holds historical data for the past 20+ years, however some unique data is only available through "Request for Information (RFI)".' },
    { question: 'Pricing', answer: 'RFIs may incur additional fees' },
    { question: 'How long are reports available on the website?', answer: 'Orion holds reports for 1 year in downloadable format. Any historical reports must be requested through a "Request for Information (RFI)".' },
  ];

  const RFIC = [
    { question: 'Intelligence Assessment', answer: 'An intelligence report pertaining to a specific requested topic...' },
    { question: 'Amplifying Information', answer: 'Expanded information pertaining to an existing intelligence report...' },
    { question: 'Location Risk Assessment', answer: 'An intelligence report of potential hazards, vulnerabilities...' },
    { question: 'Executive/Individual Exposure Report', answer: 'A comprehensive overview of exposure, risks, or involvement...' },
    { question: 'Profile – Organization', answer: 'An examination of the history, practices, and credentials of a specific entity...' },
    { question: 'Investigative Support', answer: 'INA Intelligence Analysts can aid in discovering pertinent information...' },
    { question: 'Monitoring Request', answer: 'INA Intelligence Analysts can provide live-monitoring...' },
    { question: 'Other', answer: 'INA possesses the flexibility to tailor its services...' },
  ];

  return (
    <>
      {!isMobile && (
        <div className="contact-us">
          <h1 className="page-header">Contact INA</h1>

          <div className="resources">
            <div className="column">
              <h2>Frequently Asked Questions</h2>
              {questions.map((item, index) => (
                <div key={index} className="faq-item">
                  <div
                    className={`faq-question ${expanded === index ? 'expanded' : ''}`}
                    onClick={() => toggleQuestion(index)}
                  >
                    <strong>{item.question}</strong>
                    <span style={{ marginLeft: '5px' }}>{expanded === index ? '\u25B2' : '\u25BC'}</span>
                  </div>
                  {expanded === index && <div className="faq-answer">{item.answer}</div>}
                </div>
              ))}
            </div>

            <div className="column">
              <h3 className="RFI-header">Request For Intelligence (RFI) – Categories</h3>
              {RFIC.map((item, index) => (
                <div key={index} className="faq-item">
                  <div
                    className={`faq-RFI ${expandedRFI === index ? 'expanded' : ''}`}
                    onClick={() => toggleRFI(index)}
                  >
                    <strong>{item.question}</strong>
                    <span style={{ marginLeft: '5px' }}>{expandedRFI === index ? '\u25B2' : '\u25BC'}</span>
                  </div>
                  {expandedRFI === index && <div className="faq-answer">{item.answer}</div>}
                </div>
              ))}

              <form ref={form} onSubmit={sendEmail} className="contact-form">
                <div className="form-row-modal">
                  <label className="reason-for-contact">Reason For Contact:</label>
                  <select name="dropdown" className="form-input-dropdown">
                    <option value="">Select an option</option>
                    <option value="option1">Intelligence Assessment</option>
                    <option value="option2">Amplifying Information</option>
                    <option value="option3">Location Risk Assessment</option>
                    <option value="option4">Executive/Individual Exposure Report</option>
                    <option value="option5">Profile – Organization</option>
                    <option value="option6">Investigative Support</option>
                    <option value="option7">Monitoring Request</option>
                    <option value="option8">Other</option>
                  </select>
                </div>
                <div className="form-row-modal">
                  <label className="form-label-modal">Name:</label>
                  <input type="text" name="user_name" className="form-input-modal" />
                </div>
                <div className="form-row-modal">
                  <label className="form-label-modal">Email:</label>
                  <input type="email" name="user_email" className="form-input-modal" />
                </div>
                <div className="form-row-modal">
                  <label className="form-label-modal">Company:</label>
                  <input type="text" name="company" className="form-input-modal" />
                </div>
                <div className="form-row-modal">
                  <label className="form-label-modal">Deadline:</label>
                  <input type="text" name="deadline" className="form-input-modal" />
                </div>
                <div className="form-row-modal">
                  <label className="form-label-modal">Subject:</label>
                  <input type="text" name="subject" className="form-input-modal" />
                </div>
                <div className="form-row-modal">
                  <label className="form-label-modal">Message:</label>
                  <textarea name="message" className="form-textarea-modal" rows={6} cols={50} />
                </div>
                <input className="form-submit" type="submit" value="Send" />
              </form>
            </div>
          </div>
        </div>
      )}

      {isMobile && (
          <div className="mobile-contact-us">
            <h1 className="page-header">Contact INA</h1>
        
            {/* Collapsible FAQ */}
            <div className="mobile-faq-section">
              <div
                className="mobile-faq-toggle"
                onClick={() => setExpanded(expanded === 'faq' ? null : 'faq')}
              >
                <strong>Frequently Asked Questions</strong>
                <span style={{ marginLeft: '5px' }}>
                  {expanded === 'faq' ? '\u25B2' : '\u25BC'}
                </span>
              </div>
              {expanded === 'faq' && (
                <div className="mobile-faq-list">
                  {questions.map((item, index) => (
                    <div key={index} className="faq-item">
                      <div
                        className={`faq-question ${expandedRFI === index ? 'expanded' : ''}`}
                        onClick={() => toggleRFI(index)}
                      >
                        <strong>{item.question}</strong>
                        <span style={{ marginLeft: '5px' }}>{expandedRFI === index ? '\u25B2' : '\u25BC'}</span>
                      </div>
                      {expandedRFI === index && (
                        <div className="faq-answer">{item.answer}</div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
        
            {/* Contact Form */}
            <form ref={form} onSubmit={sendEmail} className="mobile-contact-form">
              <div className="form-row">
                <label className="reason-for-contact">Reason For Contact:</label>
                <select name="dropdown" className="form-input-dropdown">
                  <option value="">Select an option</option>
                  <option value="option1">Intelligence Assessment</option>
                  <option value="option2">Amplifying Information</option>
                  <option value="option3">Location Risk Assessment</option>
                  <option value="option4">Executive/Individual Exposure Report</option>
                  <option value="option5">Profile – Organization</option>
                  <option value="option6">Investigative Support</option>
                  <option value="option7">Monitoring Request</option>
                  <option value="option8">Other</option>
                </select>
              </div>
              <div className="form-row">
                <label className="form-label">Name:</label>
                <input type="text" name="user_name" className="form-input" />
              </div>
              <div className="form-row">
                <label className="form-label">Email:</label>
                <input type="email" name="user_email" className="form-input" />
              </div>
              <div className="form-row">
                <label className="form-label">Company:</label>
                <input type="text" name="company" className="form-input" />
              </div>
              <div className="form-row">
                <label className="form-label">Deadline:</label>
                <input type="text" name="deadline" className="form-input" />
              </div>
              <div className="form-row">
                <label className="form-label">Subject:</label>
                <input type="text" name="subject" className="form-input" />
              </div>
              <div className="form-row">
                <label className="form-label">Message:</label>
                <textarea name="message" className="form-textarea" rows={6} cols={50} />
              </div>
              <input className="form-submit" type="submit" value="Send" />
            </form>
          </div>
        )}
    </>
  );
};

export default ContactUs;
